module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pxi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents.htm#ch0c"
    }
  }, [_vm._v("List of Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "mtxt"
  }, [_c('a', {
    attrs: {
      "href": "#/Preface.htm#Cap1"
    }
  }, [_vm._v("British and American POW Camps in German Territory, and British POW Camps in Italy")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "mtxt"
  }, [_c('a', {
    attrs: {
      "href": "#/Preface.htm#Cap2"
    }
  }, [_vm._v("The Extent of the Japanese Occupation by July 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "mtxt"
  }, [_c('a', {
    attrs: {
      "href": "#/Preface.htm#Cap3"
    }
  }, [_vm._v("Singapore 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "mtxt"
  }, [_c('a', {
    attrs: {
      "href": "#/Preface.htm#Cap4"
    }
  }, [_vm._v("Route of the Thailand–Burma Railway")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24a23a90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/List_of_Maps.vue
// module id = 66
// module chunks = 0